export const ROOT_URL = process.env.NODE_ENV === 'production' ? 
  'https://us-central1-instagram-audit-prod.cloudfunctions.net'
  : 'https://us-central1-instagram-audit-dev.cloudfunctions.net'

export const SUBSCRIBE = ROOT_URL + '/subscribe'
export const ANALYZE_PROFILE = ROOT_URL + '/analyzeProfile'
